import { render, staticRenderFns } from "./appointPhone.vue?vue&type=template&id=0e0c4079&scoped=true&"
import script from "./appointPhone.vue?vue&type=script&lang=js&"
export * from "./appointPhone.vue?vue&type=script&lang=js&"
import style0 from "./appointPhone.vue?vue&type=style&index=0&id=0e0c4079&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0c4079",
  null
  
)

export default component.exports